import { Stack } from '@mui/material';

import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate.tsx';

export function UpdateFlowConfigFormFields() {
  return (
    <Stack spacing={2}>
      <BlockValueTemplateField fieldName="config.entityType" label="Entity Type" />
      <BlockValueTemplateField fieldName="config.entityId" label="Entity ID" />
      <BlockValueTemplateField fieldName="config.practiceId" label="Practice ID" />
    </Stack>
  );
}
